import { useEffect, useState, type RefObject } from 'react'

/**
 * `true` en cuanto el elemento se acerca al viewport, y ya no vuelve a
 * `false`: sirve para pedir datos por fila solo cuando hacen falta (vista de
 * columna, fase 7), no para animar nada.
 */
export function useInView(ref: RefObject<Element | null>, rootMargin = '400px'): boolean {
  const [inView, setInView] = useState(false)

  useEffect(() => {
    const node = ref.current
    if (!node || inView) return
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries.some((entry) => entry.isIntersecting)) {
          setInView(true)
          observer.disconnect()
        }
      },
      { rootMargin },
    )
    observer.observe(node)
    return () => observer.disconnect()
  }, [ref, rootMargin, inView])

  return inView
}
